module.exports = __webpack_public_path__ + "media/interview_etiquette/salray-wizard-ef2eef05.jpg";